module.exports = __webpack_public_path__ + "img/4.4e74f60e.png";